import { API_URLS, fetchJson } from "@solomon-apps/shared";

// --- Response types ---

export interface MetricsKpis {
    cumulativeVolume: string;
    lpEarnings: string;
    yaasDistributions: string;
    totalPositions: string;
    apyAllTime: string;
    updatedAt: string;
}

export interface MetricsDaily {
    timezone: string;
    dates: string[];
    tradeVolumeDaily: string[];
    lpFeesDaily: string[];
    totalPositionsDaily: string[];
    yaasDistributions: string[];
    updatedAt: string;
}

// --- Fetch functions ---

export function fetchMetricsKpis(signal?: AbortSignal): Promise<MetricsKpis> {
    return fetchJson<MetricsKpis>(`${API_URLS.YAAS_METRICS}/api/yaas/metrics/kpis`, signal);
}

export function fetchMetricsDaily(signal?: AbortSignal): Promise<MetricsDaily> {
    return fetchJson<MetricsDaily>(`${API_URLS.YAAS_METRICS}/api/yaas/metrics/daily`, signal);
}
